import React from 'react'
import { Box, FormControlLabel, Switch, TextField, Typography } from '@material-ui/core'
import RichTextField from './RichTextField'

// Property snapshot + recommended-plan card auto-fill from the estimate
// contract / CRM snapshot; only the static copy is editable here.
const ExecutiveSummaryEditor = ({ data, onChange }) => {
  const noteEnabled = data?.noteEnabled === true

  return (
    <Box display="flex" flexDirection="column" style={{ gap: 16 }}>
      <TextField
        label="Headline"
        value={data?.headline || ''}
        onChange={(e) => onChange('headline', e.target.value)}
        size="small"
        variant="outlined"
        fullWidth
      />

      <TextField
        label="Included in your monthly fee"
        value={data?.includedItems || ''}
        onChange={(e) => onChange('includedItems', e.target.value)}
        size="small"
        variant="outlined"
        fullWidth
        multiline
        minRows={2}
        helperText="Separate items with ·"
      />

      <TextField
        label="Billed separately"
        value={data?.billedSeparatelyItems || ''}
        onChange={(e) => onChange('billedSeparatelyItems', e.target.value)}
        size="small"
        variant="outlined"
        fullWidth
        multiline
        minRows={2}
        helperText="Separate items with ·"
      />

      <FormControlLabel
        control={
          <Switch
            checked={noteEnabled}
            onChange={(e) => onChange('noteEnabled', e.target.checked)}
            color="primary"
          />
        }
        label="Executive note"
      />

      {noteEnabled && (
        <RichTextField
          label="Executive note"
          value={data?.noteHtml || ''}
          onChange={(v) => onChange('noteHtml', v)}
        />
      )}

      <Typography variant="caption" style={{ color: '#999' }}>
        The property snapshot and recommended-plan card fill in automatically
        from the estimate and client record.
      </Typography>
    </Box>
  )
}

export default ExecutiveSummaryEditor
